export default __webpack_public_path__ + "static/media/imageAdvisors.806a0d2b.jpg";